export default "__VITE_ASSET__BVkFOK_J__"